import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames/bind';
import { Accordion, Link, Text } from '@beef/ui-kit';
import { useIsTabletDimension } from "../../../../../hooks/useGetDimensionGroup";
import { ConsentDataProcessing } from "../../../components/ConsentDataProcessing";
import { AppButtonsMobile } from "../AppButtonsMobile";
import { AppButtonsDesktop } from "../AppButtonsDesktop";
import { MailInput } from "../MailInput";
import { SocialLinks } from "../SocialLinks";
import { Countries } from "../Countries";
import { reducedAndSortedMobileLinks } from "./utils";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var AccordionPanelContent = /*#__PURE__*/memo(function (_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('accordion-links')
  }, data.links.length > 0 && data.links.map(function (link) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('accordion-links__item'),
      key: link.name
    }, /*#__PURE__*/React.createElement(Link, {
      href: link.value,
      isNoUnderline: true,
      size: "size5-r-s",
      variant: "light"
    }, link.name));
  }));
});
export var Mobile = /*#__PURE__*/memo(function (_ref2) {
  var blocks = _ref2.blocks,
    mailInput = _ref2.mailInput,
    appButtonsMobile = _ref2.appButtonsMobile,
    appButtonsDesktop = _ref2.appButtonsDesktop,
    appHeading = _ref2.appHeading,
    socialsLinks = _ref2.socialsLinks,
    footer = _ref2.footer,
    international = _ref2.international,
    subscribeEmailURL = _ref2.subscribeEmailURL,
    subscribeEmailTextAgreementURL = _ref2.subscribeEmailTextAgreementURL,
    mobileAppClickCallback = _ref2.mobileAppClickCallback;
  var _useState = useState(reducedAndSortedMobileLinks(blocks)),
    _useState2 = _slicedToArray(_useState, 2),
    mobileLinks = _useState2[0],
    setMobileLinks = _useState2[1];
  var copyrightYear = useMemo(function () {
    return new Date().getFullYear();
  }, []);
  var isTablet = useIsTabletDimension();
  useEffect(function () {
    setMobileLinks(reducedAndSortedMobileLinks(blocks));
  }, [blocks]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('mobile')
  }, /*#__PURE__*/React.createElement(Accordion, {
    items: mobileLinks,
    panelContent: AccordionPanelContent,
    size: "size4-m",
    withLastBorder: true
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('mail-input-wrapper')
  }, /*#__PURE__*/React.createElement(MailInput, {
    subscribeEmailTextAgreementURL: subscribeEmailTextAgreementURL,
    subscribeEmailURL: subscribeEmailURL,
    texts: mailInput.texts,
    title: mailInput.texts.heading
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('app-wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('app-wrapper__description')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-m"
  }, appHeading)), isTablet ? /*#__PURE__*/React.createElement(AppButtonsDesktop, {
    appLink: appButtonsDesktop.appLink,
    appLinkIcon: appButtonsDesktop.appLinkIcon,
    appQRCodeLinkIcon: appButtonsDesktop.appQRCodeLinkIcon,
    appQRCodeLinkIconWithText: appButtonsDesktop.appQRCodeLinkIconWithText
  }) : /*#__PURE__*/React.createElement(AppButtonsMobile, {
    callback: mobileAppClickCallback,
    className: cn('app-wrapper__button'),
    data: appButtonsMobile
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('social-buttons')
  }, /*#__PURE__*/React.createElement(SocialLinks, {
    socialsLinks: socialsLinks
  })), /*#__PURE__*/React.createElement(ConsentDataProcessing, {
    personalDataButtonText: footer.personalDataButtonText,
    personalDataTextFirst: footer.personalDataTextFirst,
    personalDataTextSecond: footer.personalDataTextSecond,
    policyModalButton: footer.policyModalButton,
    policyModalText: footer.policyModalText,
    policyModalTitle: footer.policyModalTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('footer__bottom-side')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('footer__site-map')
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/customers/site-map/",
    isNoUnderline: true,
    size: "size6-m",
    variant: "dark"
  }, footer.siteMap), /*#__PURE__*/React.createElement("div", {
    className: cn('footer__copyright')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size6-m"
  }, footer.copyrightBeeline, copyrightYear))), international && /*#__PURE__*/React.createElement(Countries, {
    international: international
  }), /*#__PURE__*/React.createElement("div", null)));
});